export default __webpack_public_path__ + "static/media/ic-money.d3349896.svg";